import { createContext, useCallback, useState } from 'react'

// eslint-disable-next-line no-restricted-imports
import {
  Message,
  MessageTab,
} from 'src/components/__legacy__/layout/message-tab'
import { generateUUID } from 'src/utils/generateUUID'

type Context = {
  showing: boolean
  show: () => void
  hide: () => void
}

const context = createContext({} as Context)

/** @deprecated use useMobileOrientationAlert without this provider */
export const OrientationAlertProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [showing, setShowing] = useState(false)

  const show = useCallback(() => setShowing(true), [])
  const hide = useCallback(() => setShowing(false), [])

  const message: Message = {
    uid: generateUUID(),
    body: '画面を横向きにしてのご利用を推奨しています',
    type: 'Info',
    option: { durationMsec: 60000, closable: true },
  }

  return (
    <context.Provider value={{ showing, show, hide }}>
      {showing && <MessageTab message={message} onComplete={hide} />}
      {children}
    </context.Provider>
  )
}
